import { addToChainAfter, ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getOrders, GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import { PopulateApiParameter, chain } from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrders";
import { OrderCollectionModel } from "@insite/client-framework/Types/ApiModels";

export interface LoadOrdersExtendedParameter extends Omit<GetOrdersApiParameter, "orderTotal"> {
    orderTotal?: string;
}

type HandlerType = ApiHandler<GetOrdersApiParameter, OrderCollectionModel>;

export const PopulateApiParameterCustom: HandlerType = props => {
    const orderTotal = props.parameter.orderTotal as unknown as string | undefined;

    const numericValue = orderTotal ? orderTotal.replace(/[^0-9.]/g, "") : "";

    props.apiParameter = {
        ...props.parameter,
        orderTotal: numericValue ? parseFloat(numericValue) : undefined,
    };
};

addToChainAfter(chain, PopulateApiParameter, PopulateApiParameterCustom);
